import { Alert, Stack } from "@mui/material"
import { PreviewMappingAlert } from "slot-definitions"
import { If } from "lib/@components/switch"
import { Bound } from "lib/@components/binding/Bound"
import { usePreviewAlert } from "routes/asset-register/plugins/excel-import/use-preview-alert"

export function PreviewMappingInfo() {
    const { hasInfos, hasErrors, alerts } = usePreviewAlert()

    return (
        <Bound>
            <If truthy={hasInfos}>
                <Bound info={alerts?.info}>
                    <Alert severity="info">
                        <Stack spacing={1}>{<PreviewMappingAlert.Slot />}</Stack>
                    </Alert>
                </Bound>
            </If>
            <If truthy={hasErrors}>
                <Bound error={alerts?.error}>
                    <Alert severity="error">
                        <Stack spacing={1}>{<PreviewMappingAlert.Slot />}</Stack>
                    </Alert>
                </Bound>
            </If>
        </Bound>
    )
}
